import { Standard } from '@getvim/vim-connect';

type GetEncounterCptsAction =
  Standard.Actions.ActionsStandard[Standard.Actions.ActionNames.GET_ENCOUNTER_CPTS];

export const getEncounterCpts: {
  input: GetEncounterCptsAction['input'];
} = {
  input: {
    encounterId: '',
    patientId: '',
  },
};
